import { ViolationStatusesEnum } from 'APIPackage/KnmModule/enums/ViolationStatusesEnum';
import { mapViolationStatusToColor } from 'KnmErknmPackage/ErknmViolationsModule/constants/mapViolationStatusToColor';
import { mapViolationStatusToLabel } from 'KnmErknmPackage/ErknmViolationsModule/constants/mapViolationStatusToLabel';
import { Tooltip } from 'UIPackage/MainModule/components/Tooltip';
import { mapViolationStatusToTooltip } from 'KnmErknmPackage/ErknmViolationsModule/constants/mapViolationStatusToTooltip';

import styles from './ViolationStatus.module.scss';
import { KnmAgreementStatusEnum } from '../enums/KnmAgreementStatusEnum';
import { mapAgreementStatusToColor } from './mapAgreementStatusToColor';
import { mapAgreementStatusToLabel } from './mapAgreementStatusToLabel';

interface IViolationStatusProps {
  status: ViolationStatusesEnum | undefined | null;
  agreementStatus?: KnmAgreementStatusEnum;
}

export const ViolationStatus = ({ status, agreementStatus }: IViolationStatusProps) => {
  if (!status) {
    return null;
  }

  return (
    <div className={styles.Wrapper}>
      {!!agreementStatus && (
        <div className={styles.ViolationStatus} data-color={mapAgreementStatusToColor[agreementStatus]}>
          {mapAgreementStatusToLabel[agreementStatus]}
        </div>
      )}
      <Tooltip placement="left" content={mapViolationStatusToTooltip[status]}>
        <div className={styles.ViolationStatus} data-color={mapViolationStatusToColor[status]}>
          {mapViolationStatusToLabel[status]}
        </div>
      </Tooltip>
    </div>
  );
};
